// extracted by mini-css-extract-plugin
export default {"general-div":"GeneralForm_general-div__CVTLj","general-input":"GeneralForm_general-input__SEak8"};